const trimTrailingSlash = (value) => value.replace(/\/$/, '');

export const getApiBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL?.trim();

  if (configuredUrl) {
    return trimTrailingSlash(configuredUrl);
  }

  if (typeof window !== 'undefined') {
    return trimTrailingSlash(window.location.origin);
  }

  return '';
};

export const API = `${getApiBaseUrl()}/api`;

export const shouldUseWebSockets = () => (
  process.env.REACT_APP_ENABLE_WEBSOCKETS === 'true' ||
  process.env.NODE_ENV !== 'production'
);

export const getWebSocketBaseUrl = () => {
  const baseUrl = getApiBaseUrl();

  if (!baseUrl) {
    return '';
  }

  return baseUrl
    .replace(/^https:\/\//, 'wss://')
    .replace(/^http:\/\//, 'ws://');
};
